import { Injectable } from "@angular/core";
import { ApiService } from "@meddatacore/common";
import { Permission, PermissionGroup, PermissionGroupWithPermissions, PermissionModel } from "../../models";

@Injectable({ providedIn: 'root' })
export class PermissionService extends ApiService {
  rootEndpoint = '/api/permissions';
  tenantEndpoint = '/api/tenant/permissions';

  setPermissions(permissionGroupId: string, permissions: string[], enabled: boolean) {
    return this.http.post<PermissionGroup[]>(`${this.identityBaseUrl}${this.rootEndpoint}/enabled`, {
      permissionGroupId,
      permissions,
      enabled
    });
  }

  getPermissionGroups() {
    return this.http.get<Permission[]>(`${this.identityBaseUrl}${this.tenantEndpoint}/groups`);
  }
  getPermissionRootGroups() {
    return this.http.get<Permission[]>(`${this.identityBaseUrl}${this.tenantEndpoint}/root-groups`);
  }
  getRootPermissions() {
    return this.http.get<PermissionModel[]>(`${this.identityBaseUrl}${this.tenantEndpoint}/root-permissions`);
  }

  getPermissionGroup(groupId: string) {
    return this.http.get<PermissionGroupWithPermissions>(`${this.identityBaseUrl}${this.tenantEndpoint}/groups/${groupId}/permissions`);
  }

  createPermissionGroup(name: string) {
    const url = `${this.identityBaseUrl}${this.tenantEndpoint}/groups`;
    return this.http.post<PermissionGroup>(url, { name });
  }
  createPermissionGroupForTenant(clinicId: string) {
    const url = `${this.clinicsBaseURL}/api/clinics/${clinicId}/CreatePermissonGroup`;
    return this.http.get<any>(url);
  }
  updatePermissionGroup(id: string, name: string) {
    const url = `${this.identityBaseUrl}${this.tenantEndpoint}/groups/${id}`;
    return this.http.put<PermissionGroup>(url, { name });
  }

  deletePermissionGroup(id: string) {
    const url = `${this.identityBaseUrl}${this.rootEndpoint}/groups/${id}`;
    return this.http.delete<void>(url);
  }
  deletePermissionGrouFromTenant(id: string) {
    const url = `${this.identityBaseUrl}${this.tenantEndpoint}/groups/${id}`;
    return this.http.delete<void>(url);
  }
}
